import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../common/models/Message";
import { GroupsState } from "../models/GroupsState";

const setMessage = (state: GroupsState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;